<template>
  <router-view />
</template>

<style>
* {
  scroll-margin-top: 100px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
#navButton {
  margin: 0.2rem;
}

.logo {
  width: 5.5rem;
}

.strikethrough {
  position: relative;
  color: #2c3e50;
  margin-right: 0.5rem;
  font-size: large;
}

.strikethrough:before {
  position: absolute;
  content: "";
  left: 0;
  top: 50%;
  right: 10%;
  border-top: 2px solid;
  border-color: inherit;
  color: red;
  opacity: 80%;

  -webkit-transform: rotate(5deg);
  -moz-transform: rotate(5deg);
  -ms-transform: rotate(15deg);
  -o-transform: rotate(15deg);
  transform: rotate(10deg);
}

.section-caption h2 {
  color: #0a53be;
  text-transform: uppercase;
  text-align: left;
  position: relative;
  padding-bottom: 15px;
}

.section-caption h2::before {
  content: "";
  position: absolute;
  display: block;
  width: 50px;
  height: 4px;
  background: #50d8af;
  bottom: 0;
  left: 0;
}

.section-content ul li {
  margin-left: 40px;
  text-align: left;
  list-style-type: disc;
  line-height: 30px;
}

.section-content p {
  text-align: left;
}

.checkbox-blue[type="checkbox"] {
  border-color: #0c2e8a;
  background-color: white;
}

.checkbox-blue:checked[type="checkbox"] {
  border-color: #0c2e8a;
  background-color: #0c2e8a;
}

.radio-blue[type="radio"] {
  border-color: #0c2e8a;
  background-color: white;
}
.radio-blue:checked[type="radio"] {
  border-color: #0c2e8a;
  background-color: #0c2e8a;
}

img {
  max-width: 100%;
}

.tile {
  padding: 30px;
  box-shadow: 10px 10px 15px rgba(70, 70, 90, 0.1);
  background: #fff;
  transition: 0.5s;
  height: 100%;
}
.tile:hover {
  box-shadow: 0 0 30px rgba(70, 70, 90, 0.2);
  transform: translateY(-5px);
  -webkit-transform: translateY(-5px);
  -moz-transform: translateY(-5px);
}

.imageTogglePassword {
  position: absolute;
  bottom: -6px;
  right: 40px;
  width: 24px;
  height: 24px;
  z-index: 100;
}

.imageTogglePasswordOld {
  position: absolute;
  bottom: -6px;
  right: 10px;
  width: 24px;
  height: 24px;
  z-index: 100;
}
/*
Buttons Style
*/
.btn-standard {
  font-family: "Raleway", sans-serif;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 1px;
  display: inline-block;
  padding: 10px 32px;
  border-radius: 2px;
  transition: 0.5s;
  margin: 10px;
  color: #fff;
  background: #0c2e8a;
  border: 2px solid #0c2e8a;
}
.btn-standard:hover {
  background: none;
  color: #0c2e8a;
}

.btn-standard_payment {
  font-family: "Raleway", sans-serif;
  font-size:12px;
  font-weight: bold;
  letter-spacing: 1px;
  display: inline-block;
  padding: 4px 16px;
  border-radius: 2px;
  transition: 0.5s;
  color: #0c2e8a;
  background: none;
  border: 2px solid #0c2e8a;
}
.btn-standard_payment:disabled {
  background: none;
  color: #6c757d;
}
.btn-standard_payment:hover {
  background: #0c2e8a;
  color: #fff;
}
/*
End Buttons Style
*/

.input-subcaption {
  font-family: sans-serif;
  font-size: small;
  text-align: left;
  font-weight: normal;
  margin: 10px;
}

/*
Navbar Style
*/
.navbar {
  padding: 0;
  width: 100%;
  position: fixed;
  z-index: 99;
  top: 0;
}
.navbar ul {
  margin: 0;
  padding: 0;
  display: flex;
  list-style: none;
  align-items: center;
}
.navbar li {
  position: relative;
}
.navbar a,
.navbar a:focus {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0 10px 30px;
  font-family: "Raleway", sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #444;
  white-space: nowrap;
  transition: 0.3s;
}
.navbar a i,
.navbar a:focus i {
  font-size: 12px;
  line-height: 0;
  margin-left: 5px;
}
.navbar a:hover,
.navbar .active,
.navbar .active:focus,
.navbar li:hover > a {
  color: #50d8af;
}

.navbar .dropdown ul {
  display: block;
  position: absolute;
  left: 14px;
  top: calc(100% + 30px);
  margin: 0;
  padding: 10px 0;
  z-index: 99;
  opacity: 0;
  visibility: hidden;
  background: #fff;
  box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
  transition: 0.3s;
}
.navbar .dropdown ul li {
  min-width: 200px;
}
.navbar .dropdown ul a {
  padding: 10px 20px;
  font-size: 14px;
}
.navbar .dropdown ul a i {
  font-size: 12px;
}
.navbar .dropdown ul a:hover,
.navbar .dropdown ul .active:hover,
.navbar .dropdown ul li:hover > a {
  color: #50d8af;
}
.navbar .dropdown:hover > ul {
  opacity: 1;
  top: 100%;
  visibility: visible;
}
.navbar .dropdown .dropdown ul {
  top: 0;
  left: calc(100% - 30px);
  visibility: hidden;
}
.navbar .dropdown .dropdown:hover > ul {
  opacity: 1;
  top: 0;
  left: 100%;
  visibility: visible;
}

@media (max-width: 1366px) {
  .navbar .dropdown .dropdown ul {
    left: -90%;
  }
  .navbar .dropdown .dropdown:hover > ul {
    left: -100%;
  }
}
/*
End Navbar Style
*/

/*
Sections Style
*/
section {
  margin-bottom: 2rem;
}

section:first-of-type {
  margin-top: 5rem;
  /*padding: 40px;*/
}

/*
End Sections Style
*/

/*
General Style
*/
body {
  background: #fff;
  color: #444;
  font-family: "Open Sans", sans-serif;
}

.navbar-expand-lg .navbar-nav .nav-link {
  padding-right: 0.4rem;
  padding-left: 0.4rem;
}

a {
  color: #50d8af;
  text-decoration: none;
  transition: 0.5s;
}
a:hover,
a:active,
a:focus {
  color: #51d8af;
  outline: none;
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: bolder;
  margin: 0 0 20px 0;
  padding: 0;
}
/*
End General Style
*/
</style>
